var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81473 5.99996C7.81473 3.57998 9.71487 1.66663 11.9999 1.66663C14.285 1.66663 16.1851 3.57998 16.1851 5.99996V8.66663C16.1851 11.0866 14.285 13 11.9999 13C9.71487 13 7.81473 11.0866 7.81473 8.66663V5.99996ZM1.33325 25.2293C1.33325 22.1373 3.21669 19.2941 6.16054 18.6682C10.0963 17.8315 13.9035 17.8315 17.8393 18.6682C18.8471 18.8825 19.7177 19.3477 20.4337 19.9876C20.5115 20.0572 20.5876 20.1289 20.6619 20.2027C21.9321 21.4637 22.6666 23.3152 22.6666 25.2293C22.6666 25.8658 22.1721 26.3333 21.6211 26.3333H16.9404H2.37877C1.82772 26.3333 1.33325 25.8658 1.33325 25.2293ZM32.0594 26.3333H26.2053C26.2891 25.9774 26.3333 25.6075 26.3333 25.2293C26.3333 23.4226 25.8827 21.5905 25.013 19.977C26.3439 20.0109 27.6792 20.1764 29.0367 20.4749C31.214 20.9536 32.6666 23.154 32.6666 25.6238C32.6666 26.0747 32.3375 26.3333 32.0594 26.3333ZM21.4258 9.99996C21.4258 8.09999 22.8594 6.66663 24.4999 6.66663C26.1405 6.66663 27.574 8.09999 27.574 9.99996V12.1666C27.574 14.0666 26.1405 15.5 24.4999 15.5C22.8594 15.5 21.4258 14.0666 21.4258 12.1666V9.99996Z",
    stroke: "#003B75",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL1);
export default __webpack_public_path__ + "static/media/L1.16fda9856f1aba9c2457885e21b51c47.svg";
export { ForwardRef as ReactComponent };